import React from "react";
import {
 Box,
 Heading,
 SimpleGrid,
 Badge,
 Text,
 Alert,
 AlertIcon,
 AlertTitle,
 AlertDescription,
} from "@chakra-ui/react";
import { Home } from "lucide-react";

const EntranceExamsSection = ({ entranceExams, hostelFacilities }) => {
 const hasExams = entranceExams && entranceExams.length > 0;
 const hasHostel = hostelFacilities && hostelFacilities.available;

 if (!hasExams && !hasHostel) {
  return null;
 }

 return (
  <Box mb={8}>
   <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6}>
    {/* Entrance Exams Section */}
    {hasExams && (
     <Box>
      <Heading as="h3" size="md" mb={4}>
       Entrance Exams
      </Heading>

      <Box>
       {entranceExams.map((exam, index) => (
        <Badge
         key={index}
         colorScheme="blue"
         mr={2}
         mb={2}
         fontSize="sm"
         py={1}
         px={2}
         borderRadius="full"
        >
         {exam}
        </Badge>
       ))}
      </Box>
     </Box>
    )}

    {/* Hostel Facilities Section */}
    {hasHostel && (
     <Box>
      <Heading as="h3" size="md" mb={4} display="flex" alignItems="center">
       <Box as={Home} mr={2} />
       Hostel Facilities
      </Heading>

      <Alert status="success" variant="subtle" borderRadius="md">
       <AlertIcon />
       <Box>
        <AlertTitle fontSize="sm">Hostel Available</AlertTitle>
        <AlertDescription fontSize="sm">
         {hostelFacilities.description ||
          "On-campus housing facilities are available for students."}
        </AlertDescription>
       </Box>
      </Alert>
     </Box>
    )}
   </SimpleGrid>
  </Box>
 );
};

export default EntranceExamsSection;
